<template>
  <div class="page_admin_tournament">
    <menu class="category">
      <li v-for="category in ringoCategories" :key="`category-${category.id}`" :class="{ selected: category.id == selectedCategory }" @click="selectCategory(category.id)">
        {{ category.id | cz }}
      </li>
    </menu>
    <menu v-if="hasThreePhases" class="phase">
      <li :class="{ selected: 0 == selectedPhaseNumber }" @click="selectPhase(0)">{{ "RoundRobin" | cz }}</li>
      <li :class="{ selected: 1 == selectedPhaseNumber }" @click="selectPhase(1)">{{ "MiddleRoundRobin" | cz }}</li>
      <li :class="{ selected: 2 == selectedPhaseNumber }" @click="selectPhase(2)">{{ "Elimination" | cz }}</li>
    </menu>
    <menu v-else>
      <li :class="{ selected: 0 == selectedPhaseNumber }" @click="selectPhase(0)">{{ "RoundRobin" | cz }}</li>
      <li @click="createMiddlePhase()">+</li>
      <li :class="{ selected: 1 == selectedPhaseNumber }" @click="selectPhase(1)">{{ "Elimination" | cz }}</li>
    </menu>
    <roundRobin v-if="selectedPhaseType == 'RoundRobin'" :category="selectedCategory" :brackets="selectedPhase" :phase="selectedPhaseNumber" />
    <elimination v-else-if="selectedPhaseType == 'Elimination' || selectedPhaseType == 'DoubleElimination'" :category="selectedCategory" :bracket="selectedPhaseBracket" :phase="selectedPhaseNumber" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { _ } from "../../extend";
import roundRobin from "./parts/bracket_roundRobin.vue";
import elimination from "./parts/bracket_elimination.vue";

export default {
  name: "tournament",
  components: {
    roundRobin,
    elimination,
  },
  data: () => ({
    selectedCategory: "royalRanger_restful",
    selectedPhaseNumber: 0,
  }),
  computed: {
    ...mapState(["categories"]),
    ringoCategories() {
      return _.filter(this.categories, category => category.excludeFromRingo == false);
    },
    brackets() {
      return _.filter(this.$store.state.brackets, bracket => bracket.categoryId == this.selectedCategory);
    },
    phases() {
      return _.groupBy(this.brackets, bracket => bracket.phase);
    },
    selectedPhase() {
      var phase = this.phases[this.selectedPhaseNumber];
      return phase != null
        ? phase
        : {};
    },
    selectedPhaseBracket() {
      return _.first(this.selectedPhase);
    },
    selectedPhaseType() {
      if (this.selectedPhaseBracket != null)
        return this.selectedPhaseBracket.type;
      return "RoundRobin"; // no bracket -> roundRobin (elimination always has a bracket)
    },
    hasThreePhases() {
      return this.phases[2] != null;
    }
  },
  methods: {
    selectCategory(category) {
      this.selectedCategory = category;
    },
    selectPhase(phase) {
      this.selectedPhaseNumber = phase;
    },
    createMiddlePhase() {
      _.forEach(this.phases[1], bracket => this.$store.commit("update", {
        paths: ["brackets", bracket.id, 'phase'],
        value: 2,
      }));
    },
  },
}
</script>

<style lang="sass">
@import "../../sass/_constants.sass"
@import "../../sass/_components.sass"

.page_admin_tournament
  display: grid
  margin:
    right: auto
    left: auto
  height: 100%
  width: $w-content
  grid-auto-flow: row
  grid-auto-rows: max-content
  grid-gap: 1rem
  menu
    display: grid
    grid-auto-flow: column
    grid-template-columns: max-content
    justify-content: start
    li
      display: block
      font-weight: bold
      margin-left: 1rem
      cursor: pointer
      &:not(:last-child)::after
        content: '|'
        margin-left: 1rem
      &.selected
        color: $c-primary
        text-decoration: underline
  .admin_bracket_roundRobin, .admin_bracket_elimination
    display: grid
    grid-gap: 1rem
    grid-auto-rows: max-content
    .actions
      display: grid
      grid-auto-flow: column
      justify-content: center
</style>
